import Contenido from './components/Contenido'
export default function PaginaEjemplo() {
    return(
      <Contenido />
    )
}